import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { kebabCase } from 'lodash';

// Platform-default Export All for web form cabinets is resolved here before the Actions
// menu renders. Cabinets can opt out (cabinetCsvExport: false), rely on the default inject
// (no export entry in csv), or override fields via an explicit actionsMenuItems entry matched
// by id 'cabinetCsvExport' or cabinetCsvExportRequestBehavior (see rb defaultOptions for
// allow_form_edit override and rb examples for allow_form_view_detail override).

export const CABINET_CSV_EXPORT_BEHAVIOR = 'cabinetCsvExportRequestBehavior';
export const CABINET_CSV_EXPORT_ID = 'cabinetCsvExport';
export const buildDefaultCabinetCsvExportMenuItem = () => ({
  id: CABINET_CSV_EXPORT_ID,
  title: 'Export All',
  permission: 'ownerPermission',
  icon: 'download',
  style: 'default',
  requiresSelection: false,
  actions: [{
    type: CABINET_CSV_EXPORT_BEHAVIOR
  }]
});
export const isCabinetCsvExportMenuItem = item => {
  if (!item) {
    return false;
  }
  if (item.id === CABINET_CSV_EXPORT_ID) {
    return true;
  }
  return Array.isArray(item.actions) && item.actions.some(action => (action === null || action === void 0 ? void 0 : action.type) === CABINET_CSV_EXPORT_BEHAVIOR);
};
export const isCabinetCsvExportOptedOut = function isCabinetCsvExportOptedOut(explicitItem) {
  let cabinetDefinition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (cabinetDefinition.cabinetCsvExport === false) {
    return true;
  }
  if ((explicitItem === null || explicitItem === void 0 ? void 0 : explicitItem.enabled) === false) {
    return true;
  }
  return false;
};
export const isCabinetEligibleForCsvExport = function isCabinetEligibleForCsvExport() {
  var _web$layout;
  let cabinetDefinition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const _cabinetDefinition$fo = cabinetDefinition.formTypeIdentifiers,
    formTypeIdentifiers = _cabinetDefinition$fo === void 0 ? [] : _cabinetDefinition$fo,
    directFormType = cabinetDefinition.directFormType,
    client = cabinetDefinition.client;
  const web = client === null || client === void 0 ? void 0 : client.web;
  if (directFormType) {
    return false;
  }
  if (!web) {
    return false;
  }
  if ((_web$layout = web.layout) !== null && _web$layout !== void 0 && _web$layout.superset) {
    return false;
  }
  if (!Array.isArray(formTypeIdentifiers) || formTypeIdentifiers.length === 0) {
    return false;
  }
  return true;
};
export const mergeCabinetCsvExportMenuItem = function mergeCabinetCsvExportMenuItem() {
  let explicit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const defaults = buildDefaultCabinetCsvExportMenuItem();
  // Explicit csv fields (e.g. permission: 'allow_form_edit') override defaults; behavior
  // wiring falls back to cabinetCsvExportRequestBehavior when actions is omitted.
  return _objectSpread(_objectSpread(_objectSpread({}, defaults), explicit), {}, {
    actions: Array.isArray(explicit.actions) && explicit.actions.length ? explicit.actions : defaults.actions
  });
};
const insertDefaultExportMenuItem = items => {
  const defaultItem = buildDefaultCabinetCsvExportMenuItem();
  const deleteIndex = items.findIndex(item => {
    var _item$action;
    return ((_item$action = item.action) === null || _item$action === void 0 ? void 0 : _item$action.type) === 'bulkDelete' || kebabCase(item.title || '') === 'delete';
  });
  if (deleteIndex >= 0) {
    return [...items.slice(0, deleteIndex), defaultItem, ...items.slice(deleteIndex)];
  }
  return [...items, defaultItem];
};
export const resolveCabinetActionsMenuItems = _ref => {
  let actionsMenuItems = _ref.actionsMenuItems,
    _ref$cabinetDefinitio = _ref.cabinetDefinition,
    cabinetDefinition = _ref$cabinetDefinitio === void 0 ? {} : _ref$cabinetDefinitio;
  const items = Array.isArray(actionsMenuItems) ? [...actionsMenuItems] : [];
  const explicitIndex = items.findIndex(isCabinetCsvExportMenuItem);
  const explicitItem = explicitIndex >= 0 ? items[explicitIndex] : null;
  if (isCabinetCsvExportOptedOut(explicitItem, cabinetDefinition)) {
    return items.filter(item => !isCabinetCsvExportMenuItem(item));
  }
  if (explicitItem) {
    const merged = mergeCabinetCsvExportMenuItem(explicitItem);
    const result = [...items];
    result[explicitIndex] = merged;
    return result;
  }
  if (!isCabinetEligibleForCsvExport(cabinetDefinition)) {
    return items;
  }
  return insertDefaultExportMenuItem(items);
};
export default resolveCabinetActionsMenuItems;